import React, { createContext, useContext, useReducer } from 'react';
import { type Action, IGroupNCI } from '../types/types';
import { initialNetCarbonIntensitySate } from '../reducers/InitialStates/NetCarbonIntensityState';
import { netCarbonIntensityReducer } from '../reducers/ActionHandlers/NetCarbonIntensityHandler';

export const NetCarbonIntensityContext = createContext<{
  netCarbonIntensityData: IGroupNCI[];
  dispatch: React.Dispatch<Action>;
}>({
  netCarbonIntensityData: initialNetCarbonIntensitySate,
  dispatch: () => null,
});

export const NetCarbonIntensityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [netCarbonIntensityData, dispatch] = useReducer(
    netCarbonIntensityReducer,
    initialNetCarbonIntensitySate,
  );

  const value = React.useMemo(
    () => ({ netCarbonIntensityData, dispatch }),
    [netCarbonIntensityData, dispatch],
  );

  return (
    <NetCarbonIntensityContext.Provider value={value}>
      {children}
    </NetCarbonIntensityContext.Provider>
  );
};

export const useNetCarbonIntensity = () => {
  const context = useContext(NetCarbonIntensityContext);
  if (!context) {
    throw new Error('useNetCarbonIntensity must be used within a NetCarbonIntensityProvider');
  }
  return context;
};
